module.exports = __webpack_public_path__ + "img/gia_dung_thong_minh.8673b48d.svg";